// Shared columns for Project Details and potential Create flows

import { PICKLIST_LABELS } from "../../config/projectMetadataFields";

export function buildInfoFieldsForProject({ form, data }) {
  return [
    { label: "Name", path: "metadata.name", type: "text" },
    { label: "Short Name", path: "metadata.shortName", type: "text" },
    {
      label: "Contributor Project Name",
      path: "objectives.contributorFacingName",
      type: "text",
    },
    {
      label: "Appen Partner",
      path: "metadata.appenPartner",
      type: "select",
      picklistLabel: PICKLIST_LABELS.APPEN_PARTNER,
    },
    {
      label: "Job Category",
      path: "metadata.category",
      type: "select",
      picklistLabel: PICKLIST_LABELS.JOB_CATEGORY,
    },
    // {
    //   label: "Project Manager",
    //   path: "metadata.projectManagerId",
    //   type: "lookup",
    //   lookupObject: "Contributor",
    //   valueLabel: data?.metadata?.projectManagerName,
    //   labelPath: "metadata.projectManagerName",
    // },
    {
      label: "Project Type",
      path: "metadata.projectType",
      type: "select",
      picklistLabel: PICKLIST_LABELS.PROJECT_TYPE,
    },
    { label: "Priority", path: "metadata.projectPriority", type: "text" },
    {
      label: "Project Payment Method",
      path: "metadata.projectPaymentMethod",
      type: "select",
      picklistLabel: PICKLIST_LABELS.PROJECT_PAYMENT_METHOD,
    },
    {
      label: "Short Description",
      path: "metadata.shortDescription",
      type: "textarea",
    },
    {
      label: "Long Description",
      path: "metadata.longDescription",
      type: "textarea",
    },
    {
      label: "Project ID for Reports",
      path: "metadata.projectIdForReports",
      type: "text",
    },
    {
      label: "Workday Project ID",
      path: "metadata.workdayProjectId",
      type: "text",
    },
    {
      label: "Account",
      path: "metadata.account",
      type: "lookup",
      lookupObject: "Account",
      valueLabel: data?.metadata?.accountName || "-",
      labelPath: "metadata.accountName",
    },
    { label: "Hire Start Date", path: "metadata.hireStartDate", type: "date" },
    {
      label: "Predicted Close Date",
      path: "metadata.predictedCloseDate",
      type: "date",
    },
    {
      label: "Project Status",
      path: "metadata.projectStatus",
      type: "select",
      picklistLabel: PICKLIST_LABELS.PROJECT_STATUS,
    },
  ];
}

export function buildRequirementsFieldsForProject() {
  return [
    {
      label: "Payment Setup Required",
      path: "requirements.paymentSetupRequired",
      type: "checkbox",
    },
    {
      label: "Client Tool Account Required",
      path: "requirements.clientToolAccountRequired",
      type: "checkbox",
    },
    {
      label: "Manual Activation Required",
      path: "requirements.manualActivationRequired",
      type: "checkbox",
    },
  ];
}

export function buildStatsFieldsForProject() {
  return [
    { label: "Total Applied", path: "stats.totalApplied", type: "number" },
    { label: "Total Qualified", path: "stats.totalQualified", type: "number" },
    {
      label: "Invited Available Contributors",
      path: "stats.invitedAvailableContributors",
      type: "number",
    },
    {
      label: "Applications Received",
      path: "stats.appReceived",
      type: "number",
    },
    {
      label: "Matched Contributors",
      path: "stats.matchedContributors",
      type: "number",
    },
    { label: "AC Account", path: "stats.acAccount", type: "number" },
    {
      label: "Applied Contributors",
      path: "stats.appliedContributors",
      type: "number",
    },
    {
      label: "Registered Contributors",
      path: "stats.registeredContributors",
      type: "number",
    },
    {
      label: "Qualified Contributors",
      path: "stats.qualifiedContributors",
      type: "number",
    },
    {
      label: "Active Contributors",
      path: "stats.activeContributors",
      type: "number",
    },
    {
      label: "Production Contributors",
      path: "stats.productionContributors",
      type: "number",
    },
    { label: "Removed", path: "stats.removed", type: "number" },
  ];
}
